import { defineComponent } from 'vue'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { AddContainerForm, Values } from './add-container-form'

require('./add-container-modal.scss')

export const AddContainerModal = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sAddContainerForm: AddContainerForm,
    },
    props: {
        movement: Object,
        noCloseImmediately: Boolean,
        canChainAdd: Boolean,
        statusesToSearch: {
            type: Array,
            required: false,
        },
        excludedIds: Array,
        excludedItemsWarningMessageKey: {
            type: String,
        },
    },
    template: require('./add-container-modal.html'),
    data() {
        return {
            shouldChainAdd: false,

            initialValues: {
                identifier: null as any,
                location: null as any,
            } as Values,

            mounted: false,
        }
    },
    methods: {
        open() {
            (this.$refs.modal as any).show();
        },

        close() {
            (this.$refs.modal as any).hide();
        },

        onHide() {
            this.mounted = false;
        },

        onShow() {
            this.mounted = true;
        },

        onContainerSelected(event) {
            this.$emit('container-selected', event)
            if (!this.noCloseImmediately && (!this.canChainAdd || !this.shouldChainAdd)) {
                (this.$refs.modal as any).hide();
            }
        },

        resetSearch() {
            this.$nextTick(() => {
                this.mounted = false
                this.$nextTick(() => this.mounted = true)
            })
        },
    },
    watch: {
        mounted(value) {
            this.$emit('mounted', value);
        },
    },
})
